import React from 'react';
import useAppContext from 'flow/hooks/useAppContext';
import Spacer from 'flow/components/custom-components/spacer';
import PbxIncomingCallItem from 'flow/components/pbx/PbxIncomingCallItem';
import CentralSwitchHeader from 'flow/components/central-switch/CentralSwitchHeader';
import CentralSwitchEmptyState from 'flow/components/central-switch/CentralSwitchEmptyState';
import { QueueCallWithExtraData } from 'flow/types/Pbx';
import { TypedMap } from 'flow/types/TypedMap';
import { selectWaitingItemsInQueuesMarkedAsFavoriteOldestFirst } from 'flow/selectors/favorite-selectors';
import { useAppSelector } from 'flow/hooks/useRedux';

const MAX_NUMBER_CALLS_DISPLAY = 4;

const FavoritePbxIncomingCallCentralSwitchWidget = () => {
    const { i18next } = useAppContext();

    const queueItems = useAppSelector(
        selectWaitingItemsInQueuesMarkedAsFavoriteOldestFirst,
    );

    const IncomingCalls = () => {
        const slicedQueueItems = queueItems.slice(0, MAX_NUMBER_CALLS_DISPLAY);

        if (!slicedQueueItems?.size) {
            return (
                <CentralSwitchEmptyState
                    uniqueId={'FavoritePbxItemsIncomingCalls'}
                />
            );
        }
        const shouldDisplayAdditionalCallsItem =
            queueItems.size > MAX_NUMBER_CALLS_DISPLAY;
        const additionalCallsNumber = shouldDisplayAdditionalCallsItem
            ? queueItems.size - MAX_NUMBER_CALLS_DISPLAY
            : undefined;

        return (
            <main className="px-4">
                {slicedQueueItems.map(
                    (queueItem: TypedMap<QueueCallWithExtraData>) => {
                        if (!queueItem.get('key')) {
                            return null;
                        }
                        return (
                            <div key={queueItem.get('key')}>
                                <PbxIncomingCallItem queueItem={queueItem} />
                                <Spacer
                                    height={
                                        shouldDisplayAdditionalCallsItem
                                            ? 24
                                            : 6
                                    }
                                />
                                {shouldDisplayAdditionalCallsItem ? (
                                    <>
                                        {i18next.t('calls.queue.more', {
                                            number: additionalCallsNumber,
                                        })}
                                    </>
                                ) : null}
                            </div>
                        );
                    },
                )}
            </main>
        );
    };

    return (
        <>
            <CentralSwitchHeader>
                {i18next.t('central_switch.favorite_pbx_incoming_calls.title')}
            </CentralSwitchHeader>
            <IncomingCalls />
        </>
    );
};

export default FavoritePbxIncomingCallCentralSwitchWidget;
